import React from 'react';
import { mediosDeVenta } from '../../../utils/mediosVentaCantina';

const money = (value) =>
  new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0,
  }).format(Number(value || 0));

const fechaHora = (value) => {
  if (!value) return '—';

  return new Intl.DateTimeFormat('es-AR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(value));
};

export default function HistorialVentasTable({
  ventas,
  cargando,
  onDetalle,
}) {
  if (cargando) {
    return (
      <div className="rounded-2xl border border-blanco-puro/20 bg-azul-oscuro/60 p-8 text-center text-blanco-puro/70 shadow-xl backdrop-blur">
        Cargando ventas...
      </div>
    );
  }

  if (!ventas.length) {
    return (
      <div className="rounded-2xl border border-blanco-puro/20 bg-azul-oscuro/60 p-8 text-center shadow-xl backdrop-blur">
        <div className="text-sm font-bold text-blanco-puro">
          No hay ventas para mostrar
        </div>

        <div className="mt-1 text-xs text-blanco-puro/60">
          Probá modificando el rango de fechas.
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-blanco-puro/20 bg-azul-oscuro/60 shadow-xl backdrop-blur">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[850px]">
          <thead className="bg-azul-oscuro/80">
            <tr className="text-left text-xs uppercase tracking-wide text-blanco-puro/60">
              <th className="px-5 py-4">Venta</th>
              <th className="px-5 py-4">Fecha</th>
              <th className="px-5 py-4">Vendedor</th>
              <th className="px-5 py-4">Medio de pago</th>
              <th className="px-5 py-4 text-center">Productos</th>
              <th className="px-5 py-4 text-right">Total</th>
              <th className="px-5 py-4 text-right">Acción</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-blanco-puro/10">
            {ventas.map((venta) => {
              const cantidadProductos = Array.isArray(venta.items)
                ? venta.items.reduce(
                    (total, item) =>
                      total + Number(item.cantidad || 0),
                    0
                  )
                : 0;

              return (
                <tr
                  key={venta.id}
                  className="transition hover:bg-blanco-puro/5"
                >
                  <td className="px-5 py-4">
                    <span className="font-bold text-amarillo-dorado">
                      #{venta.id}
                    </span>
                  </td>

                  <td className="px-5 py-4 text-sm text-blanco-puro">
                    {fechaHora(venta.created_at)}
                  </td>

                  <td className="px-5 py-4 text-sm text-blanco-puro">
                    {venta.usuario?.nombre || '—'}
                  </td>

                  <td className="px-5 py-4">
                    <div className="flex flex-wrap gap-1.5">
                      {mediosDeVenta(venta).map((medio, indice) => (
                        <span
                          key={indice}
                          className="rounded-full border border-blanco-puro/15 bg-blanco-puro/5 px-3 py-1 text-xs font-semibold text-blanco-puro"
                        >
                          {medio.nombre}
                        </span>
                      ))}
                    </div>
                  </td>

                  <td className="px-5 py-4 text-center text-sm font-semibold text-blanco-puro">
                    {cantidadProductos}
                  </td>

                  <td className="px-5 py-4 text-right text-base font-bold text-blanco-puro">
                    {money(venta.total)}
                  </td>

                  <td className="px-5 py-4 text-right">
                    <button
                      type="button"
                      onClick={() => onDetalle(venta.id)}
                      className="rounded-lg border border-amarillo-dorado/50 px-3 py-1.5 text-xs font-bold text-amarillo-dorado transition hover:bg-amarillo-dorado hover:text-azul-oscuro"
                    >
                      Ver detalle
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
